import axios from '../axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: [],
    status: [
      { id: 0, name: 'Programată', icon: 'schedule', color: 'red' },
      { id: 1, name: 'Efectuată', icon: 'check_box', color: 'green' }
    ],
    dialog: null,
    filter: null,
    tab: null,
    tabItems: [
      { id: 0, text: 'Programate' },
      { id: 1, text: 'Efectuate' }
    ]
  },

  actions: {

    LOAD({ commit, rootGetters, state }, { id, filter, loadMore }) {
      return new Promise((resolve, reject) => {
        let params = {};
        if (filter) {
          for (let key in filter) {
            if (filter.hasOwnProperty(key) && filter[key] !== null) {
              params[key] = filter[key];
            }
          }
          if (filter.sortBy) {
            params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
          }

          delete params.sortBy;
          delete params.descending;
          delete params.totalItems;
        }
        axios.get(`${constants.SERVER_URL}/api/visits${id ? '/' + id : ''}`, { params })
          .then(response => response.data)
          .then(response => {
            if (id) {
              response.data.actions = response.data.actions.map(item => {
                item.path = rootGetters['actions/action'](item.action.id).path;
                return item;
              });
            }
            commit('visitActions/VISIT_ACTIONS', id ? response.data.actions : null, { root: true });
            if (response.meta) {
              if (loadMore) {
                commit('APPEND', response.data);
              } else {
                commit('VISITS', id ? [response.data] : response.data);
              }
            } else {
              commit('VISITS', id ? [response.data] : response.data);
            }
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit, state }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/visits/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/visits/${data.id}`, data)
          .then(response => response.data)
          .then(response => {
            commit('EDIT', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit, rootState }, data) {
      return new Promise((resolve, reject) => {
        axios.post(`${constants.SERVER_URL}/api/visits`, data)
          .then(response => response.data)
          .then(response => {
            commit('ADD', response.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }

  },

  mutations: {
    VISITS(state, payload) {
      state.data = payload;
    },

    APPEND(state, payload) {
      state.data = state.data.concat(payload);
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(visit => visit.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      state.delete = false;
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    },

    DIALOG(state, payload) {
      state.dialog = payload;
    },

    FILTER(state, payload) {
      state.filter = payload;
    },

    TAB(state, payload) {
      state.tab = payload;
    }
  },

  getters: {
    statusById: (state) => {
      const objectById = {};
      state.status !== null && state.status.forEach(item => {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: (state, getters) => (id) => getters.statusById[id] ? getters.statusById[id] : { name: '- Nedefinit -' }
  }
};
